









import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'

@Component
export default class AppLoading extends Vue {
  @Prop(String) readonly text!: string
}
